export var queryKeys = {
    brands: function (page, perPage, search) { return [
        'brands',
        "page:".concat(page, "-size:").concat(perPage, "-search:").concat(search || ''),
    ]; },
};
